module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_5032_burgundy.5da83c2c.jpg";